// millionContractConfig.js

// Import the ABI from a JSON file (assuming the ABI file is located in the 'abis' directory)
import millionContractABI from '../abi/millionContractABI.json';

// Define the contract address (replace '0x123...' with your contract's actual address)
export const millionContractAddress = '0x273819f7d9387ad17cbB77BEA32cd293F9BC8CdE';

// Export the ABI
export const millionAbi = millionContractABI;